(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var pdpForm = $('#pdpForm');
  if (!pdpForm) return;
  var variantSelect = $('#variantSelect', pdpForm);
  if (!variantSelect) return;

  var swatchGroups = $$('.pdp-swatches', pdpForm);
  if (!swatchGroups.length) return;

  function currentSelections() {
    var sel = [];
    swatchGroups.forEach(function (group) {
      var active = $('.pdp-swatch.active', group);
      sel[Number(group.dataset.optionIndex)] = active ? active.dataset.value : null;
    });
    return sel;
  }

  function findOptionEl(selections) {
    var options = $$('option', variantSelect);
    for (var i = 0; i < options.length; i++) {
      var parts = (options[i].dataset.options || '').split('|||');
      var isMatch = true;
      for (var j = 0; j < selections.length; j++) {
        if (selections[j] != null && parts[j] !== selections[j]) { isMatch = false; break; }
      }
      if (isMatch) return options[i];
    }
    return null;
  }

  function applyOption(opt) {
    if (!opt) return;
    variantSelect.value = opt.value;

    var priceEl = $('#pdpPrice');
    if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.priceHtml || opt.dataset.price;

    var addBtn = $('#pdpAddBtn');
    if (addBtn) {
      var avail = opt.dataset.available === 'true';
      addBtn.disabled = !avail;
      addBtn.textContent = avail ? (addBtn.dataset.labelAdd || 'Add to Bag') : 'Sold out';
    }
    $$('.pdp-buy-btn').forEach(function (bb) { bb.dataset.variantId = opt.value; });

    if (opt.dataset.image) {
      var mainImg = $('#pdpMainImg');
      if (mainImg) mainImg.src = opt.dataset.image;
      var matchThumb = $$('.pdp-thumbs button').filter(function (t) { return t.dataset.full === opt.dataset.image; })[0];
      if (matchThumb) {
        $$('.pdp-thumbs button').forEach(function (t) { t.classList.remove('active'); });
        matchThumb.classList.add('active');
      }
    }
  }

  swatchGroups.forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.pdp-swatch');
      if (!btn || btn.dataset.available === 'false') return;
      $$('.pdp-swatch', group).forEach(function (s) {
        s.classList.remove('active');
        s.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');

      var valueLabel = group.parentElement.querySelector('.pdp-option-value');
      if (valueLabel) valueLabel.textContent = btn.dataset.value;

      var selections = currentSelections();
      var opt = findOptionEl(selections);
      if (opt) {
        applyOption(opt);
      } else if (btn.dataset.variantId) {
        var direct = $$('option', variantSelect).filter(function (o) { return o.value === btn.dataset.variantId; })[0];
        applyOption(direct);
      }
    });
  });
})();
